const INITIAL_STATE = {
  data: [],
  isLoading: true,
  error: null,
  errorsData: [],
  isDefaulter: false,
};

const reducer = (state = INITIAL_STATE, action) => {
  const { payload } = action;
  switch (action.type) {
    case "DEFAULTERS_GET_DATA":
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    case "DEFAULTERS_GET_DATA_SUCCESS": {
      return {
        ...state,
        data: payload.data,
        error: null,
        isLoading: false,
      };
    }

    case "DEFAULTERS_GET_DATA_FAILURE": {
      return {
        ...state,
        data: [],
        error: payload,
        isLoading: false,
      };
    }

    case "DEFAULTERS_ERRORS_DATA": {
      return {
        ...state,
        errorsData: payload.errors.map((item) => ({
          ...item.data,
          message: item.message,
        })),
      };
    }

    case "DEFAULTERS_RESET_ERRORS_DATA": {
      return {
        ...state,
        errorsData: [],
      };
    }

    case "DEFAULTERS_UPDATE_DATA": {
      return {
        ...state,
        data: payload.newData,
      };
    }

    case "VERIFY_DEFAULTER":
      return {
        ...state,
        isDefaulter: false,
        isLoading: true,
      };

    case "VERIFY_DEFAULTER_SUCCESS": {
      return {
        ...state,
        isDefaulter: payload.isDefaulter,
        isLoading: false,
        error: null,
      };
    }

    case "VERIFY_DEFAULTER_FAILURE": {
      return {
        ...state,
        error: payload.error,
        isLoading: false,
        isDefaulter: false,
      };
    }

    default:
      return state;
  }
};

export default reducer;
